import React from 'react';
import { motion } from 'framer-motion';
import { AnimatedSection } from './AnimatedSection';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <AnimatedSection className="py-16 md:py-24 px-6 max-w-4xl mx-auto" data-id="element-163">
      <div className="text-center mb-10" data-id="element-164">
        <span className="inline-block py-1.5 px-4 rounded-full bg-sage/10 text-sage text-sm font-medium tracking-wide mb-6 border border-sage/20" data-id="element-165">
          Método Cero Cortisol
        </span>
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-charcoal mb-6 leading-tight" data-id="element-166">
          Detén el pánico en 120 segundos y recupera el mando de tu vida.
        </h1>
        <p className="text-lg md:text-xl text-charcoal/80 mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-167">
          El método biológico para apagar la ansiedad y el estrés crónico sin
          medicación, sin esperas y sin "pensar positivo".
        </p>
      </div>

      {/* Product Image */}
      <motion.div className="relative max-w-lg mx-auto mb-10" initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.3
    }} data-id="element-168">
        <img src="https://cdn.magicpatterns.com/uploads/3nvjHQsXpTPjstsmtLphnQ/heylloyd-image-1772728770119.png" alt="Controla tu Ansiedad - PDF eBook y Audio guía en tablet y teléfono" className="w-full h-auto rounded-2xl shadow-2xl shadow-charcoal/10" data-id="element-169" />
      </motion.div>

      {/* Opening Hook */}
      <div className="bg-cream rounded-2xl p-6 md:p-8 mb-10 max-w-2xl mx-auto border border-charcoal/5" data-id="element-170">
        <p className="text-charcoal/80 text-lg leading-relaxed mb-4" data-id="element-171">
          Sé exactamente cómo se siente. El pecho se aprieta, el aire no entra y
          ese pensamiento aterrador de{' '}
          <em className="text-terracotta font-medium" data-id="element-172">
            "estoy perdiendo el control"
          </em>{' '}
          empieza a nublarlo todo.
        </p>
        <p className="text-charcoal/80 text-lg leading-relaxed mb-4" data-id="element-173">
          Intentas respirar hondo, pero parece que el cuerpo no te obedece.
        </p>
        <p className="text-charcoal/90 text-lg leading-relaxed font-medium" data-id="element-174">
          No es que seas débil. Es que tu cuerpo ha encendido una alarma de
          incendio y nadie te enseñó dónde está el interruptor para apagarla.{' '}
          <span className="text-sage font-semibold" data-id="element-175">Hasta ahora.</span>
        </p>
      </div>

      <div className="text-center" data-id="element-176">
        <CTAButton text="Sí, Quiero Controlar Mi Ansiedad Ahora" data-id="element-177" />
        <p className="mt-4 text-sm text-charcoal/60" data-id="element-178">
          Compra segura • Acceso instantáneo por correo electrónico
        </p>
      </div>
    </AnimatedSection>;
}